import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
	},
	filter: {
		VyrobekvozOzn: null as string | null,
		Tablpozice: null as string | null,
		TablpoziceText: null as string | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {
		[listMutations.TABULKOVA_POZICE_SELECT_MAPPER](state, { data }) {
			state.filter.Tablpozice = data.value;
			state.filter.TablpoziceText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
